import { render, staticRenderFns } from "./qianshui.vue?vue&type=template&id=6582775f"
import script from "./qianshui.vue?vue&type=script&lang=ts"
export * from "./qianshui.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports